module.exports = __webpack_public_path__ + "images/fpc-bg-footer-mobile.webp";